import React from "react";

function Web() {
  return <div className="flex flex-1 items-center">
    <div className="text-[20px] font-medium mr-4">
        <a href="#projects" className="flex flex-row text-pink-800 font-semibold" >
          <i class="fi-rr-edit-alt option-icon mr-1"></i>Projects
        </a>
    </div>
    <div className="text-[20px] font-medium mr-4">
        <a href="#skills" className="flex flex-row text-pink-800 font-semibold items-center">
        <i class="fi-rr-laptop option-icon mr-1"></i>Skills
        </a>
    </div>
    <div className="text-[20px] font-medium mr-4">
        <a href="#work" className="flex flex-row text-pink-800 font-semibold items-center">
        <i class="fi-rr-briefcase option-icon mr-1"></i>Work
        </a>
    </div>
    <div className="text-[20px] font-medium mr-4">
        <a href="#contact" className="flex flex-row text-pink-800 font-semibold items-center">
        <i class="fi fi-rr-user option-icon mr-1"></i>Contact
        </a>
    </div>
  </div>;
}

export default Web;